import { render, staticRenderFns } from "./NoticeDetailModal.vue?vue&type=template&id=589895d9&"
import script from "./NoticeDetailModal.vue?vue&type=script&lang=js&"
export * from "./NoticeDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports